import React, { useState } from "react";
import { useAuth } from "@/context/AuthContext";
import { api, apiError } from "@/lib/apiClient";
import { toast } from "sonner";
import { useNavigate } from "react-router-dom";

export default function ChangePassword() {
  const { logout } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ ancien: "", nouveau: "", confirm: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (form.nouveau !== form.confirm) { toast.error("Les mots de passe ne correspondent pas"); return; }
    setLoading(true);
    try {
      await api.post("/auth/change-password", { ancien: form.ancien, nouveau: form.nouveau });
      toast.success("Mot de passe modifié. Reconnexion requise.");
      await logout();
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="mx-auto max-w-md">
      <h1 className="font-heading text-2xl font-extrabold tracking-tight">Changer le mot de passe</h1>
      <form onSubmit={submit} className="mt-6 space-y-4 rounded-xl border border-slate-200 bg-white p-6">
        {["ancien", "nouveau", "confirm"].map((k) => (
          <div key={k}>
            <label className="mb-1.5 block text-xs font-semibold uppercase tracking-wide text-slate-500">
              {k === "ancien" ? "Ancien mot de passe" : k === "nouveau" ? "Nouveau mot de passe" : "Confirmer"}
            </label>
            <input
              data-testid={`pwd-${k}`}
              type="password"
              required
              value={form[k]}
              onChange={(e) => setForm({ ...form, [k]: e.target.value })}
              className="w-full rounded-lg border border-slate-200 px-3 py-2.5 text-sm outline-none focus:border-slate-900"
            />
          </div>
        ))}
        <div className="flex gap-2">
          <button type="button" onClick={() => navigate(-1)} className="flex-1 rounded-lg border border-slate-200 py-2.5 text-sm font-semibold hover:bg-slate-50">Annuler</button>
          <button data-testid="pwd-submit" disabled={loading} className="flex-1 rounded-lg bg-[#0A0A0A] py-2.5 text-sm font-semibold text-white hover:bg-slate-800 disabled:opacity-60">Valider</button>
        </div>
      </form>
    </div>
  );
}
